import { render, staticRenderFns } from "./NotesPanel.vue?vue&type=template&id=735a4524&scoped=true&"
import script from "./NotesPanel.vue?vue&type=script&lang=js&"
export * from "./NotesPanel.vue?vue&type=script&lang=js&"
import style0 from "./NotesPanel.vue?vue&type=style&index=0&id=735a4524&prod&scoped=true&lang=css&"
import style1 from "./NotesPanel.vue?vue&type=style&index=1&id=735a4524&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735a4524",
  null
  
)

export default component.exports